export class FinancialYearMonthResponse {
  Successful: boolean = false;
  Message: string = '';
  ObjectTag: FinancialYearMonthData = new FinancialYearMonthData();
  // FinancialYearMonthListResponse: FinancialYearMonthListResponse[] = [];
}
export class FinancialYearMonthData {
  FinancialYearMonthListResponse: FinancialYearMonthListResponse[] = [];
}
export class FinancialYearMonthListResponse {
  FinancialYearRef: number = 0;
  FromYear: number = 0;
  ToYear: number = 0;
  ShortName: string = '';
  FromDate: string = '';
  ToDate: string = '';
  Month: number = 0;
  MonthName: string = '';
  DisplayOrder: number = 0;
}
